export enum AggregationDayType {
  day = 'day',
  week = 'week',
  month = 'month',
  year = 'year',
}

export enum AggregationPaymentStatusType {
  all = 'all',
  succeeded = 'succeeded',
  canceled = 'canceled',
  pending = 'pending',
}

export interface PaymentsFlowItem {
  date: string;
  numberOfPayments: number;
  paymentSystemHeadsetSucceeded: number;
  receptionSucceeded: number;
  vipAccessSucceeded: number;
  paymentSystemQrCodeSucceeded: number;
  sessions: number;
}

export interface PurchasesRecord {
  hour: number;
  count: number;
}

export interface CompanyAnalytics {
  companyId: string;
  payments: PaymentsFlowItem[];
  purchases: PurchasesRecord[];
}
